import { ChangeDetectionStrategy, Component, InputSignal, Signal, computed, inject, input } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

import { embedSrcOf } from '@rt-tools/cms-angular/site';
import { BlockDirective, ElemDirective } from '@rt-tools/core';

import { BLOG_BLOCK_PAGE, IBlogBlockPage } from '../blog-block-page.tokens';

const BEM_BLOCK: string = 'sc-blog-embed-block';

@Component({
    selector: 'sc-blog-embed-block',
    templateUrl: './blog-embed-block.component.html',
    styleUrl: './blog-embed-block.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        // rt-tools
        BlockDirective,
        ElemDirective,
    ],
    host: {
        class: BEM_BLOCK,
    },
})
export class BlogEmbedBlockComponent {
    readonly #sanitizer: DomSanitizer = inject(DomSanitizer);
    readonly #page: Signal<IBlogBlockPage> = inject(BLOG_BLOCK_PAGE);

    /** Подпись рамки для чтения с экрана — заголовок статьи. */
    protected readonly title: Signal<string> = computed((): string => this.#page().title);

    // Рамка получает только плеер площадки из списка, собранный в коде: адрес другого сайта сюда
    // не доходит, поэтому доверие Angular выдаётся собранному адресу, а не введённому.
    protected readonly src: Signal<SafeResourceUrl | null> = computed((): SafeResourceUrl | null => {
        const src: string | null = embedSrcOf(this.content());
        // eslint-disable-next-line sonarjs/no-angular-bypass-sanitization -- the address is built by embedSrcOf from the provider list and a checked video id, never taken from the block text
        return src === null ? null : this.#sanitizer.bypassSecurityTrustResourceUrl(src);
    });

    /** Адрес страницы видео, как его ввёл редактор. */
    public readonly content: InputSignal<string> = input.required<string>();
}
